import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { keymirror } from 'utils/keymirror'

export const USER_ACTION_TYPES = generateApiActionTypes('USER')

export const USER_PROFILE_ACTION_TYPES = generateApiActionTypes('USER_PROFILE')

export const USER_UPDATE_ACTION_TYPES = generateApiActionTypes('USER_UPDATE')

export const APPROVE_PARENT_USER_ACTION_TYPES = generateApiActionTypes('APPROVE_PARENT_USER')

export const REJECT_PARENT_USER_ACTION_TYPES = generateApiActionTypes('REJECT_PARENT_USER')

export const CONFIRM_PARENT_USER_ACTION_TYPES = generateApiActionTypes('CONFIRM_PARENT_USER')

/*
 * Child User Actions
 */
export const FETCH_CHILD_USERS_ACTION_TYPES = generateApiActionTypes('FETCH_CHILD_USERS')
export const CREATE_CHILD_USER_ACTION_TYPES = generateApiActionTypes('CREATE_CHILD_USER')
export const EDIT_CHILD_USER_ACTION_TYPES = generateApiActionTypes('EDIT_CHILD_USER')
export const DELETE_CHILD_USER_ACTION_TYPES = generateApiActionTypes('DELETE_CHILD_USER')

export const PASSWORD_ACTION_TYPES = keymirror({
  PASSWORD_REQUEST: null,
  PASSWORD_SUCCESS: null,
  PASSWORD_FAILURE: null,
  PASSWORD_ALREADY_CREATED: null,
})

export const SIGN_IN_ACTION_TYPES = generateApiActionTypes('SIGN_IN')

export const RESEND_INVITE_ACTION_TYPES = generateApiActionTypes('RESEND_INVITE')

export const USER_DELETE_DIALOG_ACTION_TYPES = keymirror({
  SHOW_USER_DELETE_DIALOG: null,
  HIDE_USER_DELETE_DIALOG: null,
})

export const DELETE_USER_ACTION_TYPES = generateApiActionTypes('DELETE_USER')
export const UNDELETE_USER_ACTION_TYPES = generateApiActionTypes('UNDELETE_USER')
export const UNDELETE_SET_USER = 'UNDELETE_SET_USER'
export const UNDELETE_CLEAR_USER = 'UNDELETE_CLEAR_USER'

export const SMS_ACTION_TYPES = generateApiActionTypes('SMS')
export const SEARCH_USER_ACTION_TYPES = generateApiActionTypes('SEARCH_USER')
export const CREATE_USER_ACTION_TYPES = generateApiActionTypes('CREATE_USER')

export const CLEAR_ERROR_MESSAGES = 'CLEAR_ERROR_MESSAGES'
export const CLEAR_USER = 'CLEAR_USER'

export const EDIT_DIALOG_ACTIONS = keymirror({
  OPEN_DIALOG: null,
  CLOSE_DIALOG: null,
})

export const getUserDetails = (id, actionTypes = USER_ACTION_TYPES) => {
  const requestData = {
    endpoint: ENDPOINTS.users,
    id,
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(actionTypes),
    },
  }
}

export const getParentUserDetails = (id, actionTypes = USER_ACTION_TYPES) => {
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    id,
  }
  return {
    type: undefined,
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(actionTypes),
    },
  }
}

export const getUserProfileDetails = id => getUserDetails(id, USER_PROFILE_ACTION_TYPES)
export const getParentUserProfileDetails = id => getParentUserDetails(id, USER_PROFILE_ACTION_TYPES)

export const updateUserProfileDetails = payload => {
  const requestData = {
    endpoint: ENDPOINTS.users,
    id: payload.id,
    method: 'PUT',
    body: {
      user: payload,
    },
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(USER_UPDATE_ACTION_TYPES),
    },
  }
}

export const updateParentUserProfileDetails = payload => {
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    id: payload.id,
    method: 'PUT',
    body: {
      parentUser: payload,
    },
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(USER_UPDATE_ACTION_TYPES),
    },
  }
}

export const createPassword = payload => {
  const requestData = {
    endpoint: ENDPOINTS.password,
    method: 'PUT',
    body: {
      user: payload,
    },
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(PASSWORD_ACTION_TYPES),
    },
  }
}

export const signIn = payload => {
  const requestData = {
    endpoint: ENDPOINTS.signIn,
    method: 'POST',
    body: {
      userLogin: payload,
    },
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(SIGN_IN_ACTION_TYPES),
    },
  }
}

export const passwordAlreadyCreated = () => ({
  type: PASSWORD_ACTION_TYPES.PASSWORD_ALREADY_CREATED,
})

export const passwordCreateFailure = error => ({
  error,
  type: PASSWORD_ACTION_TYPES.PASSWORD_FAILURE,
})

export const openDialog = () => ({ type: EDIT_DIALOG_ACTIONS.OPEN_DIALOG })
export const closeDialog = () => ({ type: EDIT_DIALOG_ACTIONS.CLOSE_DIALOG })

export const resendInvite = email => {
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    method: 'POST',
    group: 'invitation_email',
    body: { user: { email } },
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(RESEND_INVITE_ACTION_TYPES),
    },
  }
}

export const showDeleteUserDialog = userId => ({
  type: USER_DELETE_DIALOG_ACTION_TYPES.SHOW_USER_DELETE_DIALOG,
  payload: { userId },
})

export const hideDeleteUserDialog = () => ({
  type: USER_DELETE_DIALOG_ACTION_TYPES.HIDE_USER_DELETE_DIALOG,
})

export const deleteUser = id => {
  const requestData = {
    endpoint: ENDPOINTS.users,
    method: 'DELETE',
    id,
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(DELETE_USER_ACTION_TYPES),
    },
  }
}

export const setUndeleteUserId = id => ({
  type: UNDELETE_SET_USER,
  payload: id,
})

export const clearUndelete = () => ({
  type: UNDELETE_CLEAR_USER,
})

export const undeleteUser = id => {
  const requestData = {
    endpoint: ENDPOINTS.users,
    method: 'POST',
    id,
    group: 'undelete',
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(UNDELETE_USER_ACTION_TYPES),
    },
  }
}

export const deleteParentUser = id => {
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    method: 'DELETE',
    id,
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(DELETE_USER_ACTION_TYPES),
    },
  }
}

export const approveParentUser = id => {
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    method: 'POST',
    id,
    group: 'approve',
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(APPROVE_PARENT_USER_ACTION_TYPES),
    },
  }
}

export const rejectParentUser = id => {
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    method: 'POST',
    id,
    group: 'reject',
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(REJECT_PARENT_USER_ACTION_TYPES),
    },
  }
}

export const confirmParentUser = id => {
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    method: 'POST',
    id,
    group: 'confirm',
  }
  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(CONFIRM_PARENT_USER_ACTION_TYPES),
    },
  }
}

export const searchUsers = (searchTerm, searchParents) => {
  const searchType = searchParents ? 'parents' : 'user'

  const requestData = {
    endpoint: ENDPOINTS.search,
    params: {
      filters: {
        searchOptions: [{ type: searchType }],
        searchTerm,
      },
    },
  }

  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(SEARCH_USER_ACTION_TYPES),
    },
  }
}

export const createUser = user => {
  const requestData = {
    endpoint: ENDPOINTS.users,
    method: 'POST',
    body: {
      user,
    },
  }

  return {
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(CREATE_USER_ACTION_TYPES),
    },
  }
}

export const fetchChildUsers = parentUserId => {
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    method: 'GET',
    id: parentUserId,
    group: 'users',
    params: {
      filters: {
        include_deleted: true,
      },
    },
  }

  return {
    payload: {
      actionTypes: Object.keys(FETCH_CHILD_USERS_ACTION_TYPES),
      callApi: true,
      requestData,
    },
  }
}

export const createChildUser = childUser => {
  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    method: 'POST',
    id: childUser.parentUserId,
    group: 'users',
    body: {
      user: {
        ...childUser,
      },
    },
  }

  return {
    payload: {
      actionTypes: Object.keys(CREATE_CHILD_USER_ACTION_TYPES),
      callApi: true,
      requestData,
    },
  }
}

export const editChildUser = childUser => {
  const group = `users/${childUser.id}`

  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    method: 'PUT',
    id: childUser.parentUserId,
    body: {
      user: {
        ...childUser,
      },
    },
    group,
  }

  return {
    payload: {
      actionTypes: Object.keys(EDIT_CHILD_USER_ACTION_TYPES),
      callApi: true,
      requestData,
    },
  }
}

export const deleteChildUser = childUser => {
  const group = `users/${childUser.id}`

  const requestData = {
    endpoint: ENDPOINTS.parentUsers,
    method: 'DELETE',
    id: childUser.parentUserId,
    group,
  }

  return {
    payload: {
      actionTypes: Object.keys(DELETE_CHILD_USER_ACTION_TYPES),
      userId: childUser.id,
      callApi: true,
      requestData,
    },
  }
}

export const clearErrorMessages = () => ({
  type: 'CLEAR_ERROR_MESSAGES',
})

export const clearUser = () => ({
  type: 'CLEAR_USER',
})
